// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 部署流程模型 POST /official_document/flow/deploy */
export async function postOfficialDocumentFlowDeploy(
  body: string,
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>('/official_document/flow/deploy', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
